document.addEventListener( 'DOMContentLoaded', function() {
    document.getElementsByTagName("body")[0].classList.add("overflow-visible");
});